import React, { useEffect, useState } from "react";
import api from "../lib/api";

const CONFETTI = ["🎉", "✨", "🪩", "💎", "🥇", "🌊", "🎊"];

/**
 * MilestoneBadges — pearl-earnings badges strip + confetti celebration
 * when a new milestone was just crossed (then marked seen).
 */
export default function MilestoneBadges() {
  const [data, setData] = useState(null);
  const [celebrate, setCelebrate] = useState(null);

  useEffect(() => {
    api.get("/creator/milestones").then(({ data: d }) => {
      setData(d);
      if ((d.unseen || []).length > 0) {
        const m = d.milestones.find((x) => x.pearls === Math.max(...d.unseen));
        setCelebrate(m);
        setTimeout(() => {
          setCelebrate(null);
          api.post("/creator/milestones/seen").catch(() => {});
        }, 6000);
      }
    }).catch(() => {});
  }, []);

  if (!data) return null;
  const awarded = new Set(data.awarded || []);

  return (
    <>
      {celebrate && (
        <div className="fixed inset-0 z-[95] pointer-events-none flex items-center justify-center" data-testid="milestone-celebration">
          <style>{`@keyframes gwConfettiFall { 0% { transform: translateY(-10vh) rotate(0deg); opacity: 1; } 100% { transform: translateY(110vh) rotate(720deg); opacity: 0.4; } }`}</style>
          {Array.from({ length: 36 }).map((_, i) => (
            <span
              key={i}
              className="absolute text-2xl"
              style={{
                left: `${(i * 137) % 100}%`,
                top: "-10vh",
                animation: `gwConfettiFall ${2.4 + (i % 5) * 0.5}s linear ${(i % 8) * 0.25}s forwards`,
              }}
            >
              {CONFETTI[i % CONFETTI.length]}
            </span>
          ))}
          <div className="crystal-glass rounded-3xl px-8 py-6 text-center animate-fade-up">
            <div className="text-6xl animate-bounce">{celebrate.emoji}</div>
            <p className="text-jam-gold text-[10px] tracking-[0.35em] uppercase font-black mt-2">Milestone Unlocked</p>
            <p className="text-cream text-3xl font-black tracking-tighter mt-1">{celebrate.label}</p>
            <p className="text-papaya text-sm font-bold mt-1">{celebrate.pearls.toLocaleString()} pearls earned</p>
          </div>
        </div>
      )}

      <section className="mt-8" data-testid="milestone-badges">
        <p className="text-cream/50 text-xs tracking-[0.25em] uppercase font-bold mb-3">Milestones</p>
        <div className="flex gap-2 overflow-x-auto pb-1">
          {data.milestones.map((m) => {
            const got = awarded.has(m.pearls);
            return (
              <div
                key={m.pearls}
                data-testid={`milestone-${m.pearls}`}
                className={`flex-shrink-0 rounded-2xl px-3 py-2.5 text-center border transition-colors ${
                  got ? "crystal-glass border-jam-gold/50" : "bg-white/[0.03] border-white/5 opacity-50"
                }`}
              >
                <div className={`text-2xl ${got ? "" : "grayscale"}`}>{m.emoji}</div>
                <p className={`text-[9px] tracking-[0.15em] uppercase font-black mt-1 ${got ? "text-jam-gold" : "text-cream/40"}`}>{m.label}</p>
                <p className="text-cream/40 text-[9px] mt-0.5">{m.pearls >= 1000 ? `${m.pearls / 1000}K` : m.pearls} pearls</p>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}
